import React, { Fragment, useState } from 'react'
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { WorkOrderBlogComponent } from '../../../components/WorkOrderBlog/WorkOrderBlog'
import { PickingRouteComponent } from '../../../components/PickingRoute/PickingRoute'
import { WorkOrderDetail } from '../../../interfaces/WorkOrderOutbound'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { OrderDetailViewerModern } from '../component/OrderDetailViewerModern'

interface BlogWorkOrderModalProps {
  blogWorkOrderModalState: ModalReturnType<{
    workOrderId: number
    woDetail: WorkOrderDetail[]
  }>
  handleRequestWorkOrders: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const BlogWorkOrderModal: React.FC<BlogWorkOrderModalProps> = ({
  blogWorkOrderModalState,
  handleRequestWorkOrders
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState<boolean>(false)

  const handleClose = () => {
    handleRequestWorkOrders()
    blogWorkOrderModalState.closeModal()
  }

  return (
    <Modal
      open={blogWorkOrderModalState.isOpen}
      maxWidth={blogWorkOrderModalState.size}
      onClose={handleClose}
      title={blogWorkOrderModalState.title}
      cancelButton={{
        action: handleClose,
        title: 'Salir'
      }}
    >
      <Fragment>
        <Box style={{ marginBottom: '16px' }}>
          <SectionHeader
            title='Detalle de Rutas'
          />
          <div className={classes.accordeonSummary}>
            <Typography>Rutas de Picking</Typography>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </div>
          <Collapse in={open} timeout='auto' unmountOnExit>
            {blogWorkOrderModalState.extendedProps ? (
              <PickingRouteComponent
                workOrderId={blogWorkOrderModalState.extendedProps.workOrderId}
              />
            ) : (
              <Typography>OT no ha sido seleccionada</Typography>
            )}
          </Collapse>
        </Box>

        <Box style={{ marginBottom: '16px' }}>
          <SectionHeader
            title='Detalle de Pedido'
          />
          {blogWorkOrderModalState.extendedProps && (
            <OrderDetailViewerModern
              workOrderDetails={blogWorkOrderModalState.extendedProps.woDetail}
            />
          )}
          {!blogWorkOrderModalState.extendedProps && (
            <Typography>OT no ha sido seleccionada</Typography>
          )}
        </Box>

        <Box style={{ marginBottom: '16px' }}>
          <SectionHeader
            title='Bitácora'
          />
          <Box
            sx={{
              p: 2,
              borderRadius: 3,
              backgroundColor: 'common.white',
              border: '1px solid',
              borderColor: 'divider'
            }}
          >
            {blogWorkOrderModalState.extendedProps && (
              <WorkOrderBlogComponent
                workOrderId={blogWorkOrderModalState.extendedProps?.workOrderId}
              />
            )}
            {!blogWorkOrderModalState.extendedProps && (
              <Typography>OT no ha sido seleccionada</Typography>
            )}
          </Box>
        </Box>
      </Fragment>
    </Modal>
  )
}

interface SectionHeaderProps {
  title: string
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => (
  <Stack
    spacing={0.35}
    sx={{
      mb: 1.25,
      pl: 1.5,
      borderLeft: '4px solid',
      borderColor: 'primary.main'
    }}
  >
    <Typography variant='h6' sx={{ fontWeight: 700, lineHeight: 1.1 }}>
      {title}
    </Typography>
  </Stack>
)

const useStyles = makeStyles(() => ({
  accordeonSummary: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .03)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    },
    justifyContent: 'space-between',
    paddingLeft: '16px',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: '4px',
    borderBottom: '2px solid rgba(0, 0, 0, .125)'
  }
}))
